import { useMemo } from 'react';

import { Config, PortalType } from 'config';
import teamImage from 'assets/images/auth-team.jpg';
import hospitalImage from 'assets/images/auth-hospital.jpg';

export const useAuthData = () =>
  useMemo(() => {
    switch (Config.portalType.raw) {
      case PortalType.Team:
        return {
          image: teamImage,
        };
      case PortalType.Hospital:
        return {
          image: hospitalImage,
        };
      case PortalType.PetOwner:
        return {};
    }
  }, []);
